import moment from 'moment';
import getTimeWithTimezone from 'shared/utils/dates/formatTimeWithTimezone';

export const getScheduleDateRange = (timeView, timezone, isMobile, startOfWeek = 'Monday', daysData = null) => {
	let firstday, lastday;

	if (timeView === 'day' && !isMobile) {
		const today = moment();

		firstday = today.startOf('day');
		lastday = today.endOf('day');
	} else {
		// Calculate week boundaries based on organization's start_of_week
		const dayMap: { [key: string]: number } = {
			Sunday: 0,
			Monday: 1,
			Tuesday: 2,
			Wednesday: 3,
			Thursday: 4,
			Friday: 5,
			Saturday: 6,
		};

		// Convert startOfWeek from /api/days/id format to day label
		let startDayLabel = startOfWeek;
		if (daysData && Array.isArray(daysData) && startOfWeek.startsWith('/api/days/')) {
			const dayObj = daysData.find((day: any) => {
				const dayId = day['@id'] || `/api/days/${day.id}`;
				return dayId === startOfWeek;
			});
			if (dayObj && dayObj.label) {
				startDayLabel = dayObj.label;
			}
		}

		const startDayOfWeek = dayMap[startDayLabel] ?? 1; // Default to Monday
		const currentDate = moment();
		const currentDay = currentDate.day();

		// Calculate how many days to subtract to get to the start of the business week
		const daysToSubtract = (currentDay - startDayOfWeek + 7) % 7;
		
		firstday = currentDate.clone().subtract(daysToSubtract, 'days').startOf('day');
		// Business week is exactly 7 days
		lastday = firstday.clone().add(6, 'days').endOf('day');
	}

	return getTimeWithTimezone(firstday, lastday, timezone);
};
